import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { useIsCookieManagerInitialized, useShowCookieManager } from "@faro-lotv/foreign-observers";
import { useMediaQueryList } from "@hooks/use-media-query";
import { useToast, Button } from "@flat-ui";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useAppSelector } from "@store/store-helper";
import { isUserLoggedInSelector } from "@store/user/user-selector";

/** Allow user to manage the cookie manager in account settings */
export function AccountCookiesPreferences() {
  const $ = _c(14);
  const {
    trackEvent
  } = useTrackEvent();
  const {
    openToast
  } = useToast();
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const isCookieManagerInitialized = useIsCookieManagerInitialized();
  const showCookieManager = useShowCookieManager();
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);
  let t0;
  if ($[0] !== openToast) {
    t0 = function showManageCookiesError() {
      openToast({
        title: "Unknown error loading cookie manager.",
        message: "Please reload the page or try again later.",
        variant: "error"
      });
    };
    $[0] = openToast;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const showManageCookiesError = t0;
  let t1;
  if ($[2] !== isCookieManagerInitialized || $[3] !== isUserLoggedIn || $[4] !== showCookieManager || $[5] !== showManageCookiesError || $[6] !== trackEvent) {
    t1 = function onCookiePreferences() {
      trackEvent({
        name: UserProfile.manageCookies,
        props: {
          isUserLoggedIn
        }
      });
      if (!isCookieManagerInitialized) {
        showManageCookiesError();
        return;
      }
      try {
        showCookieManager();
      } catch {
        showManageCookiesError();
      }
    };
    $[2] = isCookieManagerInitialized;
    $[3] = isUserLoggedIn;
    $[4] = showCookieManager;
    $[5] = showManageCookiesError;
    $[6] = trackEvent;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const onCookiePreferences = t1;
  if (isScreenSmOrSmaller) {
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        width: "100%"
      };
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== onCookiePreferences) {
      t3 = <Button onClick={onCookiePreferences} sx={t2}>Open cookies preferences</Button>;
      $[9] = onCookiePreferences;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  let t2;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT
    };
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== onCookiePreferences) {
    t3 = <FaroTextButton onClick={onCookiePreferences} sx={t2}>Open cookies preferences</FaroTextButton>;
    $[12] = onCookiePreferences;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}